const prefix = 'instance-subscriptions-section';

export const i18n = {
    newSubscription: {
        id: `${prefix}.newSubscription`,
        defaultMessage: 'New Subscription',
    },
    name: {
        id: `${prefix}.name`,
        defaultMessage: 'Name',
    },
    productCode: {
        id: `${prefix}.productCode`,
        defaultMessage: 'Product Code',
    },
    quoteId: {
        id: `${prefix}.quoteId`,
        defaultMessage: 'Quote ID',
    },
    serialNumber: {
        id: `${prefix}.serialNumber`,
        defaultMessage: 'Serial Number',
    },
    type: {
        id: `${prefix}.type`,
        defaultMessage: 'Type',
    },
    quantity: {
        id: `${prefix}.quantity`,
        defaultMessage: 'Quantity',
    },
    startDate: {
        id: `${prefix}.startDate`,
        defaultMessage: 'Start Date',
    },
    finishDate: {
        id: `${prefix}.finishDate`,
        defaultMessage: 'End Date',
    },
    status: {
        id: `${prefix}.status`,
        defaultMessage: 'Status',
    },
    noSubscriptionsTitle: {
        id: `${prefix}.noSubscriptionsTitle`,
        defaultMessage: 'No subscriptions',
    },
    noSubscriptionsMessage: {
        id: `${prefix}.noSubscriptionsMessage`,
        defaultMessage: 'There are no subscriptions for this instance.',
    },
} as const;
